import type { PatientDemographics } from "@/features/Patient/PatientBar/types/patientDemographics";
import type { PatientDemographicsEligibility } from "./types";

export type MismatchField = "Name" | "DOB" | "Gender" | "Address";

const norm = (s?: string | null) => (s ?? "").trim().toLowerCase();

export const getMismatchedFields = (
  emr: PatientDemographics | undefined,
  payer: PatientDemographicsEligibility | undefined,
): MismatchField[] => {
  if (!emr || !payer) return [];
  const out: MismatchField[] = [];

  const emrFirst = norm(emr.demographics.nameFirst);
  const emrLast = norm(emr.demographics.nameLast);
  const payerFirst = norm(payer.firstName);
  const payerLast = norm(payer.lastName);
  if (
    (payerFirst && payerFirst !== emrFirst) ||
    (payerLast && payerLast !== emrLast)
  ) {
    out.push("Name");
  }

  if (payer.dateOfBirth && emr.demographics.dob) {
    const emrDob = emr.demographics.dob.slice(0, 10);
    const payerDob = payer.dateOfBirth.slice(0, 10);
    if (emrDob !== payerDob) out.push("DOB");
  }

  if (payer.gender && emr.demographics.administrativeGender) {
    const e = norm(emr.demographics.administrativeGender)[0];
    const p = norm(payer.gender)[0];
    if (e && p && e !== p) out.push("Gender");
  }

  // EMR demographics endpoint only carries city + state, so address comparison
  // is best-effort — line1/zip differences won't be detected client-side.
  const emrCity = norm(emr.administrative.addressCity);
  const emrState = norm(emr.administrative.addressState);
  const payerCity = norm(payer.address?.city);
  const payerState = norm(payer.address?.state);
  if (
    (payerCity && payerCity !== emrCity) ||
    (payerState && payerState !== emrState)
  ) {
    out.push("Address");
  }

  return out;
};
